const ENCRYPTION_KEY = process.env.REACT_APP_API_ENCRYPT_KEY;
const ENCRYPTION_IV = process.env.REACT_APP_API_ENCRYPT_IV;

export async function encryptData(
  plainText,
  encryptionKey = normalizeKey(ENCRYPTION_KEY),
  encryptionIV = normalizeIV(ENCRYPTION_IV)
) {
  try {
    // Convert plaintext to ArrayBuffer
    const plaintextArrayBuffer = new TextEncoder().encode(plainText);

    // Import the encryption key
    const keyBuffer = await crypto.subtle.importKey(
      "raw",
      encryptionKey,
      "AES-CTR",
      false,
      ["encrypt"]
    );

    // Encrypt the plaintext
    const encryptedData = await crypto.subtle.encrypt(
      {
        name: "AES-CTR",
        counter: encryptionIV,
        length: 64,
      },
      keyBuffer,
      plaintextArrayBuffer
    );

    // Convert the encrypted data to Base64
    const encryptedString = btoa(
      String.fromCharCode(...new Uint8Array(encryptedData))
    );
    return encryptedString;
  } catch (error) {
    throw new Error("Encryption error: " + error);
  }
}

export async function decryptData(
  cipherText,
  encryptionKey = normalizeKey(ENCRYPTION_KEY),
  encryptionIV = normalizeIV(ENCRYPTION_IV)
) {
  try {
    const encryptedArrayBuffer = Uint8Array.from(atob(cipherText), (c) =>
      c.charCodeAt(0)
    ).buffer;
    const keyBuffer = await crypto.subtle.importKey(
      "raw",
      encryptionKey,
      "AES-CTR",
      false,
      ["decrypt"]
    );
    const decryptedData = await crypto.subtle.decrypt(
      {
        name: "AES-CTR",
        counter: encryptionIV,
        length: 64,
      },
      keyBuffer,
      encryptedArrayBuffer
    );

    // Convert decrypted data to string
    const decryptedString = new TextDecoder().decode(decryptedData);
    const jsonObject = JSON.parse(decryptedString);
    return jsonObject;
  } catch (error) {
    throw new Error("Decryption error: " + error);
  }
}
function normalizeKey(key) {
  const encoder = new TextEncoder();
  const keyBytes = encoder.encode(key);

  if (keyBytes.length === 16 || keyBytes.length === 32) {
    return keyBytes;
  }

  // Pad or truncate to 32 bytes (256 bits)
  const normalized = new Uint8Array(32);
  normalized.set(keyBytes.slice(0, 32)); // truncate if too long
  return normalized;
}
function normalizeIV(iv) {
  const ivBytes = new TextEncoder().encode(iv);
  if (ivBytes.length !== 16) {
    throw new Error("AES-CTR IV must be exactly 16 bytes");
  }
  return ivBytes;
}
